export default (callSign: string) => {
  const snippet =
    `// Somewhere else in the script
    $("#jplayer").jPlayer( {
        swfPath: 'js/jquery.jplayer.swf',
        ready: function () {
          $(this).jPlayer("setMedia", {
            mp3: "http://stream.statsradio.com/"
          }).jPlayer("play");
        },
        solution: "html, flash",
        supplied: "mp3",
        errorAlerts: true,
      });

    // Somewhere in <body>
    <div id="jplayer"></div>
    
    ra("${callSign}", {
      jPlayer: {
        id: "jplayer"
      }
    });`;

  return snippet;
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/snippets/jPlayerSnippet.js